import { safetyTips } from "@/mocks/movieData";
import SectionHeading, { Section } from "./SectionHeading";

export default function SafetyTips() {
  return (
    <Section id="safety" className="bg-background-50">
      <SectionHeading
        eyebrow="安全提示"
        accent="accent"
        title="避开仿冒页面，这几条请先看一眼"
        description="观影类入口是仿冒页面较多的一类。下面几点是判断页面是否可信的常用标准，遇到不符合的情况直接关闭即可。"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
        {safetyTips.map((tip) => (
          <article
            key={tip.id}
            className="flex items-start gap-4 rounded-lg bg-background-100 border border-background-200 p-4 md:p-5"
          >
            <span className="shrink-0 w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
              <i className={`${tip.icon} text-2xl`} aria-hidden="true"></i>
            </span>
            <div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{tip.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{tip.desc}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-6 rounded-lg bg-accent-50 border border-accent-200 p-4 md:p-5 flex items-start gap-3">
        <i className="ri-alert-line text-xl text-accent-700 mt-0.5" aria-hidden="true"></i>
        <p className="text-sm text-foreground-700 leading-relaxed">
          遇到要求下载未知插件、安装来路不明的扩展程序，或页面反复弹出全屏广告的情况，建议直接关闭页面并回到本页重新选择线路。
        </p>
      </div>
    </Section>
  );
}